<template>
  <div class="container">
    <div v-for="(item, index) in list" :key="index">
      <div class="cover">
        <iain-image-domain w="66" h="66" r="10" :src="item.icon" />
      </div>
      <div class="label">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { label: '活动章程', icon: 'static/img/1-hdzc.png' },
        { label: '捐赠名录', icon: 'static/img/2-jz.png' },
        { label: '财务公布', icon: 'static/img/3-cwgb.png' },
        { label: '集资名录', icon: 'static/img/4-jz.png' },
        { label: '预算明细', icon: 'static/img/5-ys.png' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-between;
  padding: 30px 30px 20px;
  text-align: center;
  background-color: #ffffff;

  .cover {
    display: flex;
    align-content: center;
    justify-content: center;
    width: 90upx;
    height: 90upx;
  }

  .label {
    padding-top: 20px;
    font-size: 24px;
    color: #666666;
  }
}
</style>
